module.exports = __webpack_public_path__ + "arrow_left.9ff5f5be.svg";